import { createContext } from "react";

const adminInterestContext = createContext();

export default adminInterestContext;
